import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { OptionActiveT } from "../const";
import { FieldTitle } from "../styles";
import { LayoutConst } from "core";

export const Container = styled.div`
    display: flex;
    flex-flow: column;
`;


export const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    max-height: 72px;
    overflow-y: auto;
    padding-right: 16px;

    ::-webkit-scrollbar {
        height: 2px;
        width: 2px;
    }
    ::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
    }
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 10px 12px;
        max-height: 98px;
    }
`;

export const ActiveItemWrapper = styled(FlexBox)`
    padding: 5px 40px 5px 16px;
    border-radius: 5px;
    border: 1px solid #909090;
    height: 30px;
    flex-flow: row;
    width: fit-content;
    max-width: calc(564px - 80px);
    position: relative;


    * {
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.3px;
        text-transform: lowercase;
        white-space: nowrap;

        overflow: hidden;
        text-overflow: ellipsis;
    }

    .value_1 {
        color: ${p => p.theme.not_saved_modal.channelTitle};
    }

    svg {
        path {
            stroke: ${p => p.theme.not_saved_modal.channelTitle};
            fill: ${p => p.theme.not_saved_modal.channelTitle};
        }
    }

    .devider {
        margin: 0 4px 0 4px;
    }

    .devider, .value_2 {
        color: #909090;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 50px);
    }

`;

const SvgWrapper = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
`;

const RepostItem: FC<{item: any, onClick: () => void }> = ({ item, onClick }) => {
    return <ActiveItemWrapper>
        <span className="value_1">{item.label}</span>
        {!!item?.parent && (
            <>
                <span className="devider">|</span>
                <span className="value_2">{item.parent.label}</span>
            </>
        )}
        <SvgWrapper onClick={onClick}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4L12 12" stroke="#151514" stroke-linecap="round"/>
                <path d="M4 12L12 4" stroke="#151514" stroke-linecap="round"/>
            </svg>
        </SvgWrapper>
    </ActiveItemWrapper>
}

export const ActiveRepostsList: FC<{array: OptionActiveT[], onRemove: (id: string, parentId: string) => void }> = ({ array, onRemove}) => {
    const { t, i18n: {language} } = useTranslation();
    return (
        <Container>
            <FieldTitle>{t('repost.modal.feed_title_delete')}</FieldTitle>
            <TagContainer>
                {array?.map((item) => {
                    return <RepostItem item={item} key={item.value} onClick={() => onRemove(item.value, item.parent?.value)}/>
                })}
            </TagContainer>
        </Container>
    )
}import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { OptionActiveT } from "../const";
import { FieldTitle } from "../styles";
import { LayoutConst } from "core";

export const Container = styled.div`
    display: flex;
    flex-flow: column;
`;


export const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    max-height: 72px;
    overflow-y: auto;
    padding-right: 16px;

    ::-webkit-scrollbar {
        height: 2px;
        width: 2px;
    }
    ::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
    }
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 10px 12px;
        max-height: 98px;
    }
`;

export const ActiveItemWrapper = styled(FlexBox)`
    padding: 5px 40px 5px 16px;
    border-radius: 5px;
    border: 1px solid #909090;
    height: 30px;
    flex-flow: row;
    width: fit-content;
    max-width: calc(564px - 80px);
    position: relative;


    * {
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.3px;
        text-transform: lowercase;
        white-space: nowrap;

        overflow: hidden;
        text-overflow: ellipsis;
    }

    .value_1 {
        color: ${p => p.theme.not_saved_modal.channelTitle};
    }

    svg {
        path {
            stroke: ${p => p.theme.not_saved_modal.channelTitle};
            fill: ${p => p.theme.not_saved_modal.channelTitle};
        }
    }

    .devider {
        margin: 0 4px 0 4px;
    }

    .devider, .value_2 {
        color: #909090;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 50px);
    }

`;

const SvgWrapper = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
`;

const RepostItem: FC<{item: any, onClick: () => void }> = ({ item, onClick }) => {
    return <ActiveItemWrapper>
        <span className="value_1">{item.label}</span>
        {!!item?.parent && (
            <>
                <span className="devider">|</span>
                <span className="value_2">{item.parent.label}</span>
            </>
        )}
        <SvgWrapper onClick={onClick}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4L12 12" stroke="#151514" stroke-linecap="round"/>
                <path d="M4 12L12 4" stroke="#151514" stroke-linecap="round"/>
            </svg>
        </SvgWrapper>
    </ActiveItemWrapper>
}

export const ActiveRepostsList: FC<{array: OptionActiveT[], onRemove: (id: string, parentId: string) => void }> = ({ array, onRemove}) => {
    const { t, i18n: {language} } = useTranslation();
    return (
        <Container>
            <FieldTitle>{t('repost.modal.feed_title_delete')}</FieldTitle>
            <TagContainer>
                {array?.map((item) => {
                    return <RepostItem item={item} key={item.value} onClick={() => onRemove(item.value, item.parent?.value)}/>
                })}
            </TagContainer>
        </Container>
    )
}